import Link from "next/link";
import { gutterCalculator } from "../../../util/utils";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

const colCount = 4;
const List = ({ data, index }) => {
  let gutterClass = gutterCalculator("gutter-space", index - 1);
  return (
    <Link
      href={data.href}
      prefetch={false}
      className={`btn-outline md:mb-2.5 md:mt-0 md:pb-3 md:pl-2.5 md:pr-2 md:pt-2.5 pb-4 pl-3 pr-3 pt-3 text-left bg-white 
      ${gutterClass} `}
    >
      <div className="icon-title-wrap md:mb-0">
        <figure dangerouslySetInnerHTML={{ __html: data.icon }} />
        <h3 className="lg:mt-3 lg:text-center md:text-left text-brandcolor">
          {data.title}
        </h3>
      </div>
      <style jsx>{`
        a {
          height: 100%;
        }
        @media (min-width: ${viewport.tablet.md}) {
          .gutter-space {
            margin-left: 40px;
            margin-right: 40px;
          }
        }
        @media (min-width: ${viewport.tablet.sm}) and (max-width: ${viewport
            .tablet.md}) {
          .gutter-space {
            margin-left: 20px;
            margin-right: 20px;
          }
        }
      `}</style>
    </Link>
  );
};
export default function FeaturesGridWithLink({ data }) {
  return (
    <div
      className={`container card--default card--feature lg:mt-10 lg:mb-8 md:mt-5 fx--${
        colCount <= 3 ? `tl` : `sb`
      }  has-${colCount <= 3 ? `three` : `four`}-col`}
    >
      {data.map((item, index) => {
        return <List key={index} data={item} index={index + 1} />;
      })}
    </div>
  );
}
